import { TLanguage } from '@com/core/common/types/locale';
import sivviConfig from '@com/core/sivvi/sivviConfig';
import {
    TLocalizedMainCategory,
    TLocalizedNavCategory,
    TLocalizedFooter,
    TMainCategory,
    TNavCategory,
    TFooter,
    TSivviNavCategory,
    TMainCategorySubItems,
    TImageLink,
} from '../types/navigation/navigation';

export const localizeMainCategory = (lang: TLanguage, mainCategories: TLocalizedMainCategory[]): TMainCategory[] => {
    const localizedCategory = mainCategories.map((mainCategory, index) => {
        const images = mainCategory.image.desktop.map(img => ({
            url: img.url,
            img: img[lang],
        }));

        return {
            id: index,
            title: mainCategory.title[lang],
            color: mainCategory.color,
            images,
            items: mainCategory.items.map(subCategory => ({
                title: subCategory.title[lang],
                url: subCategory.url,
                items:
                    subCategory.items?.map(item => ({
                        text: item[lang],
                        url: item.url,
                    })) || [],
                banners:
                    subCategory.banners?.map(banner => ({
                        img: banner.img,
                        url: banner.url,
                    })) || [],
                topBrands:
                    subCategory.topBrands?.map(topBrand => ({
                        img: topBrand.img,
                        url: topBrand.url,
                    })) || [],
            })),
        };
    });

    return localizedCategory;
};

// Not sure if this is the best approach. Check with @nipun
export const localizeFashionMainCategory = (
    lang: TLanguage,
    mainCategories: TLocalizedMainCategory[],
): TMainCategory[] => {
    const configCategories = sivviConfig.categories;

    const localizedCategory = configCategories.map((category, index) => {
        const mainCategory = mainCategories[category][0];
        let image;
        if (Array.isArray(mainCategory.image)) {
            image = mainCategory.image[0][lang];
        } else {
            image = {
                desktop: mainCategory.image.desktop[0][lang],
                mobile: mainCategory.image.mobile[0][lang],
            };
        }

        const itemsArray = (items: TMainCategorySubItems[]): TMainCategorySubItems[] => {
            const item = items.map(cat => ({ text: cat[lang], url: cat.url }));
            return item;
        };

        const bannersArray = (banners: TImageLink[]): TImageLink[] => {
            const item = banners.map(cat => ({ img: cat[lang], url: cat.url }));
            return item;
        };

        const itemsArr = mainCategory.items.map(subCategory => ({
            title: subCategory.title[lang],
            url: subCategory.url,
            items: itemsArray(subCategory.items),
            banners: bannersArray(subCategory.banners),
            topBrands: subCategory.topBrands,
        }));

        return {
            id: index,
            title: mainCategory.title[lang],
            color: mainCategory.color,
            image,
            items: itemsArr,
        };
    });

    return localizedCategory;
};

export const localizeNavCategory = (lang: TLanguage, data: TLocalizedNavCategory[]): TNavCategory[] => {
    const localizedNavCategory = data.map(category => ({
        title: category.title[lang],
        url: category.url,
        categories:
            category.categories?.map(subCategory => ({
                text: subCategory[lang],
                url: subCategory.url,
            })) || [],
        banners:
            category.banners?.map(banner => ({
                url: banner.url,
                img: banner[lang],
            })) || [],
        brands:
            category.brands?.map(brand => ({
                url: brand.url,
                text: brand[lang],
            })) || [],
    }));

    return localizedNavCategory;
};

export const localizeSivviNavCategory = (lang: TLanguage, navCategories: TSivviNavCategory): TSivviNavCategory => {
    return navCategories;
};

export const localizeFooter = (lang: TLanguage, footerCategories: TLocalizedFooter[]): TFooter[] => {
    const processedFooterData = footerCategories.map(footerCategory => ({
        title: footerCategory.title[lang],
        url: footerCategory.url,
        items: footerCategory.items.map(item => ({
            title: item[lang],
            url: item.url,
        })),
    }));
    return processedFooterData;
};
